// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container styling */
.forgot-password-container {
    max-width: 400px;
    margin: 100px auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    background-color: #f9f9f9;
    text-align: center;
}

/* Header styling */
.forgot-password-header {
    margin-bottom: 20px;
    font-family: Arial, sans-serif;
    font-size: 24px;
    color: #333;
}

/* Form styling */
.forgot-password-form {
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Input group styling */
.input-group {
    margin-bottom: 15px;
    width: 100%;
    text-align: left;
}

.input-group label {
    display: block;
    font-family: Arial, sans-serif;
    font-size: 14px;
    margin-bottom: 5px;
    font-weight: bold;
    color: #333;
}

.input-group input {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #ccc;
    font-size: 14px;
}

/* Error and success messages */
.error-message {
    color: red;
    font-size: 13px;
    margin-bottom: 10px;
}

.success-message {
    color: green;
    font-size: 13px;
    margin-bottom: 10px;
}

/* Button styling */
.reset-button {
    padding: 10px 20px;
    background-color: #007bff;
    color: #faf4f4;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-family: Arial, sans-serif;
    font-size: 16px;
}

.reset-button:hover {
    background-color: #0056b3;
}

/* Back to login link */
.back-to-login {
    margin-top: 15px;
    font-family: Arial, sans-serif;
    font-size: 14px;
}

.back-to-login a {
    color: #007bff;
    text-decoration: none;
}

.back-to-login a:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/components/ForgotPassword.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,gBAAgB;IAChB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["/* Container styling */\n.forgot-password-container {\n    max-width: 400px;\n    margin: 100px auto;\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    background-color: #f9f9f9;\n    text-align: center;\n}\n\n/* Header styling */\n.forgot-password-header {\n    margin-bottom: 20px;\n    font-family: Arial, sans-serif;\n    font-size: 24px;\n    color: #333;\n}\n\n/* Form styling */\n.forgot-password-form {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n/* Input group styling */\n.input-group {\n    margin-bottom: 15px;\n    width: 100%;\n    text-align: left;\n}\n\n.input-group label {\n    display: block;\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n    margin-bottom: 5px;\n    font-weight: bold;\n    color: #333;\n}\n\n.input-group input {\n    width: 100%;\n    padding: 10px;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    font-size: 14px;\n}\n\n/* Error and success messages */\n.error-message {\n    color: red;\n    font-size: 13px;\n    margin-bottom: 10px;\n}\n\n.success-message {\n    color: green;\n    font-size: 13px;\n    margin-bottom: 10px;\n}\n\n/* Button styling */\n.reset-button {\n    padding: 10px 20px;\n    background-color: #007bff;\n    color: #faf4f4;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    font-family: Arial, sans-serif;\n    font-size: 16px;\n}\n\n.reset-button:hover {\n    background-color: #0056b3;\n}\n\n/* Back to login link */\n.back-to-login {\n    margin-top: 15px;\n    font-family: Arial, sans-serif;\n    font-size: 14px;\n}\n\n.back-to-login a {\n    color: #007bff;\n    text-decoration: none;\n}\n\n.back-to-login a:hover {\n    text-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
